export const PRODUCTION_PORTAL_PATH = '/production/portal';
export const PRODUCTION_PANEL_SHOP_PATH = '/production/panel-shop';
export const PRODUCTION_PANEL_SHOP_TAB_ROUTES = Object.freeze([
  { id: 'work-procedures', label: 'Work Procedures', path: `${PRODUCTION_PANEL_SHOP_PATH}/work-procedures` },
  { id: 'documents', label: 'Documents', path: `${PRODUCTION_PANEL_SHOP_PATH}/documents` },
]);
export const PRODUCTION_SCHEDULE_PATH = '/production/schedule';
export const PRODUCTION_ASSEMBLY_SCHEDULE_PATH = '/production/schedule/assembly';
export const PRODUCTION_ASSEMBLERS_PATH = '/production/assemblers';
export const PRODUCTION_ASSEMBLY_CHANGE_LOG_PATH = '/production/schedule/assembly/change-log';
export const PRODUCTION_SHIPPING_PATH = '/production/shipping';
export const PRODUCTION_SHIPPING_TAB_ROUTES = Object.freeze([
  { id: 'display', label: 'Display', permissionKey: 'shipping.display', path: PRODUCTION_SHIPPING_PATH },
  { id: 'end-of-shift', label: 'End of Shift Log', permissionKey: 'shipping.end-of-shift', path: `${PRODUCTION_SHIPPING_PATH}/end-of-shift` },
  { id: 'shipping-details', label: 'Shipping Details', permissionKey: 'shipping.shipping-details', path: `${PRODUCTION_SHIPPING_PATH}/shipping-details` },
  { id: 'data-entry', label: 'Data Entry', permissionKey: 'shipping.data-entry', path: `${PRODUCTION_SHIPPING_PATH}/data-entry` },
  { id: 'packing-list-status', label: 'Packing List Status', permissionKey: 'shipping.packing-list-status', path: `${PRODUCTION_SHIPPING_PATH}/packing-list-status` },
  { id: 'on-hold-ready-to-ship', label: 'On Hold Ready to Ship', permissionKey: 'shipping.on-hold-ready-to-ship', path: `${PRODUCTION_SHIPPING_PATH}/on-hold-ready-to-ship` },
  { id: 'change-log', label: 'Change Log', permissionKey: 'shipping.change-log', path: `${PRODUCTION_SHIPPING_PATH}/change-log` },
]);
export const PRODUCTION_SHIPPING_CONTAINER_PATHS = Object.freeze(PRODUCTION_SHIPPING_TAB_ROUTES.map(({ path }) => path));
export const PRODUCTION_NORTH_PRAIRIE_PATH = '/production/north-prairie';
export const PRODUCTION_REPORTS_PATH = '/production/reports';
export const PRODUCTION_ON_TIME_DELIVERY_PATH = '/production/on-time-delivery';

export const PRODUCTION_SCHEDULE_TAB_ROUTES = Object.freeze([
  {
    id: 'enhancedJobSchedule',
    label: 'Job Schedule',
    permissionKey: 'schedule.job-schedule',
    path: PRODUCTION_SCHEDULE_PATH,
  },
  {
    id: 'engineeringCalendar',
    label: 'Engineering Schedule',
    permissionKey: 'schedule.engineering-schedule',
    path: '/production/schedule/engineering',
  },
  {
    id: 'engineeringOptimizer',
    label: 'Engineering Optimizer',
    permissionKey: 'schedule.engineering-optimizer',
    path: '/production/schedule/engineering-optimizer',
  },
  {
    id: 'readyToSchedule',
    label: 'Ready to Schedule',
    permissionKey: 'schedule.ready-to-schedule',
    path: '/production/schedule/ready-to-schedule',
  },
  {
    id: 'moveRequests',
    label: 'Move Requests',
    permissionKey: 'schedule.move-requests',
    path: '/production/schedule/move-requests',
  },
  {
    id: 'releasePendingCSO',
    label: 'Release Pending CSO',
    permissionKey: 'schedule.release-pending-cso',
    path: '/production/schedule/release-pending-cso',
  },
  {
    id: 'onHoldJobs',
    label: 'On Hold Jobs',
    permissionKey: 'schedule.on-hold-jobs',
    path: '/production/schedule/on-hold',
  },
  {
    id: 'pendingInPortal',
    label: 'CSO',
    permissionKey: 'schedule.pending-in-portal',
    path: '/production/schedule/cso',
  },
  {
    id: 'fullReleaseStatusMismatch',
    label: 'Full Release Mismatch',
    permissionKey: 'schedule.full-release-mismatch',
    path: '/production/schedule/full-release-mismatch',
  },
  {
    id: 'CanceledJobs',
    label: 'Canceled Jobs',
    permissionKey: 'schedule.canceled-jobs',
    path: '/production/schedule/canceled',
  },
  {
    id: 'shippedJobs',
    label: 'Shipped Jobs',
    permissionKey: 'schedule.shipped-jobs',
    path: '/production/schedule/shipped',
  },
  {
    id: 'scheduleChangeLog',
    label: 'Schedule Change Log',
    permissionKey: 'schedule.change-log',
    path: '/production/schedule/change-log',
  },
  {
    id: 'search',
    label: 'Search',
    permissionKey: 'schedule.search',
    path: '/production/schedule/search',
  },
]);

export const PRODUCTION_ASSEMBLY_TAB_ROUTES = Object.freeze([
  {
    id: 'assemblySchedule',
    label: 'Assembly Schedule',
    permissionKey: 'assembly.schedule',
    path: PRODUCTION_ASSEMBLY_SCHEDULE_PATH,
  },
  {
    id: 'assemblyAssemblers',
    label: 'Assemblers',
    permissionKey: 'assembly.assemblers',
    path: PRODUCTION_ASSEMBLERS_PATH,
  },
  {
    id: 'assemblyChangeLog',
    label: 'Schedule Change Log',
    permissionKey: 'assembly.change-log',
    path: PRODUCTION_ASSEMBLY_CHANGE_LOG_PATH,
  },
]);

export const PRODUCTION_NORTH_PRAIRIE_TAB_ROUTES = Object.freeze([
  {
    id: 'csm',
    label: 'CSM',
    permissionKey: null,
    path: '/production/north-prairie/csm',
  },
  {
    id: 'enclosures',
    label: 'Enclosures',
    permissionKey: 'user.csm-enclosure-table',
    path: '/production/north-prairie/enclosures',
  },
  {
    id: 'shipped-enclosures',
    label: 'Shipped Enclosures',
    permissionKey: null,
    path: '/production/north-prairie/shipped-enclosures',
  },
  {
    id: 'hdpe',
    label: 'HDPE',
    permissionKey: 'user.np-jobs',
    path: '/production/north-prairie/hdpe',
  },
]);

export const PRODUCTION_REPORT_ROUTES = Object.freeze([
  {
    id: 'onTimeDelivery',
    label: 'On Time Delivery',
    permissionKey: 'user.on-time-delivery',
    path: PRODUCTION_ON_TIME_DELIVERY_PATH,
  },
]);

export const PRODUCTION_SCHEDULE_CONTAINER_PATHS = Object.freeze(
  PRODUCTION_SCHEDULE_TAB_ROUTES.map(({ path }) => path)
);

export const PRODUCTION_ASSEMBLY_CONTAINER_PATHS = Object.freeze(
  PRODUCTION_ASSEMBLY_TAB_ROUTES.map(({ path }) => path)
);

export const PRODUCTION_NORTH_PRAIRIE_CONTAINER_PATHS = Object.freeze([
  PRODUCTION_NORTH_PRAIRIE_PATH,
  ...PRODUCTION_NORTH_PRAIRIE_TAB_ROUTES.map(({ path }) => path),
]);

export const PRODUCTION_REPORT_CONTAINER_PATHS = Object.freeze([
  PRODUCTION_REPORTS_PATH,
  ...PRODUCTION_REPORT_ROUTES.map(({ path }) => path),
]);

const normalizePath = (pathname = '') => {
  const normalizedPath = String(pathname).replace(/\/+$/, '').toLowerCase();
  return normalizedPath || '/';
};

const buildRouteHelpers = (routes) => {
  const tabByPath = Object.fromEntries(
    routes.map(({ id, path }) => [normalizePath(path), id])
  );
  const pathByTab = Object.fromEntries(
    routes.map(({ id, path }) => [id, path])
  );

  return {
    getTab: (pathname) => tabByPath[normalizePath(pathname)] || null,
    getPath: (tabId) => pathByTab[tabId] || null,
  };
};

const scheduleRouteHelpers = buildRouteHelpers(PRODUCTION_SCHEDULE_TAB_ROUTES);
const assemblyRouteHelpers = buildRouteHelpers(PRODUCTION_ASSEMBLY_TAB_ROUTES);
const shippingRouteHelpers = buildRouteHelpers(PRODUCTION_SHIPPING_TAB_ROUTES);
export const getProductionShippingTabFromPath = shippingRouteHelpers.getTab;
export const getProductionShippingPathForTab = shippingRouteHelpers.getPath;
const northPrairieRouteHelpers = buildRouteHelpers(PRODUCTION_NORTH_PRAIRIE_TAB_ROUTES);
const reportRouteHelpers = buildRouteHelpers(PRODUCTION_REPORT_ROUTES);

export const getProductionScheduleTabFromPath = scheduleRouteHelpers.getTab;
export const getProductionSchedulePathForTab = scheduleRouteHelpers.getPath;
export const getProductionAssemblyTabFromPath = assemblyRouteHelpers.getTab;
export const getProductionAssemblyPathForTab = assemblyRouteHelpers.getPath;
export const getProductionNorthPrairieTabFromPath = northPrairieRouteHelpers.getTab;
export const getProductionNorthPrairiePathForTab = northPrairieRouteHelpers.getPath;
export const getProductionReportFromPath = reportRouteHelpers.getTab;
export const getProductionPathForReport = reportRouteHelpers.getPath;
